import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/use-auth'
import { useLocale } from 'src/hooks/use-locale'
import { REDIRECT_AFTER_LOGIN_PARAM } from 'src/providers/auth.provider'

export const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth()
  const { locale } = useLocale()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading || isAuthenticated) {
      return
    }

    const loginPath = `/${locale}/login`
    const attemptedPath = location.pathname + location.search

    const redirectTo =
      location.pathname !== loginPath
        ? `${loginPath}?${REDIRECT_AFTER_LOGIN_PARAM}=${encodeURIComponent(attemptedPath)}`
        : loginPath

    navigate(redirectTo, { replace: true })
  }, [isAuthenticated, isLoading, locale, location.pathname, location.search, navigate])

  if (isLoading || !isAuthenticated) {
    return (
      <div className="c-min-h-screen c-flex c-items-center c-justify-center">
        <div className="c-text-gray-600">Loading...</div>
      </div>
    )
  }

  return <Outlet />
}
